import type { FC } from "react";
import { AdvisorPendingPickerRow } from "web_myplann/Advisor/Components/AdvisorPendingPickerRow";
import type { AgentAssignedListItemResponseDTO } from "web_myplann/Infrastructure/Api/Api";

type Props = {
	advisors: AgentAssignedListItemResponseDTO[];
	approvingIds: number[];
	onApprove: (id: number) => void;
	onRefuse: (advisor: AgentAssignedListItemResponseDTO) => void;
};

export const AdvisorPendingPickerList: FC<Props> = ({
	advisors,
	approvingIds,
	onApprove,
	onRefuse,
}) => (
	<>
		{advisors.map((advisor) => (
			<AdvisorPendingPickerRow
				key={advisor.uid}
				advisor={advisor}
				approving={approvingIds.includes(advisor.id)}
				onApprove={() => onApprove(advisor.id)}
				onRefuse={() => onRefuse(advisor)}
			/>
		))}
	</>
);
